import {
  SET_PORTFOLIO_DATA,
  SET_COMPANY_DETAILS,
  SET_ASSETS_DETAILS,
  SET_TOKEN_PITCHES
} from './actionTypes';
import { mockServerResponse } from '@mocks/mockServerResponse';
import CompanyMockService from '@mocks/Company.mock.service';
import PitchMockService from '@mocks/Pitch.mock.service';
import { IPortfolioCompany } from '@portfolio/IPortfolioReducer';
import SPVMockService from '@mocks/SPV.mock.service';
import { ISPV } from '@appInterfaces/spv.interfaces';

const getEquities = () =>
  mockServerResponse([
    CompanyMockService.getEquity(),
    CompanyMockService.getEquity(200, 2),
  ]).then(resp => resp);

const getTokens = () =>
  mockServerResponse(PitchMockService.getTokenPitchesDetails(2)).then(
    resp => resp
  );

const getMockedCompanyDetailsData = (companyIds: number[]) =>
  mockServerResponse(CompanyMockService.getCompanies(companyIds[0])).then(
    resp => resp
  );

const getMockedSPVData = (companyIds: number[]) =>
  mockServerResponse([
    SPVMockService.getSPVs(companyIds[0])[0],
    SPVMockService.getSPVs(companyIds[1])[1],
  ]).then(resp => resp);

const getMockedAssetsBalanceData = (assetsIds: number[]) =>
  mockServerResponse(SPVMockService.getAssetBalances(assetsIds[0])).then(
    resp => resp
  );

const getMockedPitchesData = (companyIds: number[]) =>
  mockServerResponse(PitchMockService.getPitches(companyIds[0])).then(
    resp => resp
  );

export const setPortfolioData = () => (dispatch: Function): Promise<void> => {
  return Promise.all([getEquities(), getTokens()]).then((resp) => {
    dispatch({
      type: SET_PORTFOLIO_DATA,
      payload: resp,
    });
    return Promise.resolve();
  });
};

export const setAdditionalPortfolioData = (companies: IPortfolioCompany[]) => (
  dispatch: Function
) => {
  const companyIds = companies.map(company => company.id);

  getMockedCompanyDetailsData(companyIds).then((resp: { items: unknown[] }) => {
    dispatch({
      type: SET_COMPANY_DETAILS,
      payload: resp.items,
    });
  });

  getMockedSPVData(companyIds).then((resp: unknown[]) => {
    const assetsIds: number[] = [];

    resp.forEach((spv: ISPV) => {
      spv.assets.forEach((asset) => {
        assetsIds.push(asset.id);
      });
    });

    getMockedAssetsBalanceData(assetsIds).then((respAssets) => {
      dispatch({
        type: SET_ASSETS_DETAILS,
        payload: { spvs: resp, assets: respAssets },
      });
    });

    if (
      companies.map(company => typeof company.tokenPitch !== undefined)
        .length !== 0
    ) {
      getMockedPitchesData(companyIds).then((resp: { items: unknown[] }) => {
        dispatch({
          type: SET_TOKEN_PITCHES,
          payload: resp.items,
        });
      });
    }
  });
};
